<template>
  <div />
</template>
<script>
export default {
  name: "Logout",
  data: function () {
    return {};
  },
  created: async function () {
    await this.$store.dispatch("USERACCOUNTS_LOGOUT");
    await this.$router.push("/");
  },
};
</script>
